import React, { useState } from 'react'

import { FiMonitor, FiTablet, FiSmartphone, FiInfo } from 'react-icons/fi'

import type { CustomGridBreakpointKey } from '@/types/dashboard-types'

import { Button } from '../button'

interface BreakpointToolbarProps {
  activeBreakpoint: CustomGridBreakpointKey
  onBreakpointChange: (breakpoint: CustomGridBreakpointKey) => void
  currentViewport?: CustomGridBreakpointKey
}

export default function BreakpointToolbar({
  activeBreakpoint,
  onBreakpointChange,
  currentViewport,
}: BreakpointToolbarProps) {
  const [showPopover, setShowPopover] = useState(false)
  const breakpoints = [
    { key: 'lg' as CustomGridBreakpointKey, label: 'Desktop', icon: FiMonitor },
    { key: 'md' as CustomGridBreakpointKey, label: 'Tablet', icon: FiTablet },
    { key: 'sm' as CustomGridBreakpointKey, label: 'Mobile', icon: FiSmartphone },
  ]

  return (
    <div className="flex flex-col w-full justify-start items-start gap-2">
      <span className="text-sm bg-accent/50 py-1 px-4 rounded-full flex justify-between items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-accent block"></span>In Edit Mode
      </span>
      <div className=" flex flex-row w-full justify-start items-center gap-4">
        <div>
          <div className="bg-base-100 text-base-content rounded-field shadow-md p-0.5 flex flex-col gap-2">
            <div className="space-x-2">
              {breakpoints.map(({ key, icon: Icon }) => {
                const isActive = activeBreakpoint === key
                const isCurrentViewport = currentViewport === key
                return (
                  <Button
                    variation="ghost"
                    key={key}
                    children={
                      <div className="flex flex-col justify-center items-center text-xs ">
                        <Icon
                          className={`${isActive ? 'text-base-100' : isCurrentViewport ? 'text-base-content' : 'text-base-content'} text-xl `}
                        />
                        <div></div>
                      </div>
                    }
                    handleClick={() => onBreakpointChange(key)}
                    className={`${isActive ? 'bg-base-content' : 'bg-base-100 hover:bg-base-200'} ${isCurrentViewport && !isActive ? 'bg-base-content/20' : ''}`}
                  />
                )
              })}
            </div>
          </div>
        </div>
        {/* Helper text */}
        <div
          className="relative"
          onMouseEnter={() => setShowPopover(true)}
          onMouseLeave={() => setShowPopover(false)}
          onClick={() => setShowPopover(!showPopover)}
        >
          <div className="text-xl text-primary relative z-50 bg-base-300 p-2 rounded-md">
            <FiInfo />
          </div>
          {showPopover && (
            <div className="absolute  left-1/2 -translate-x-1/2 md:-translate-x-1/4 top-full  w-[calc(100vw-12rem)] lg:left-0 lg:top-0 lg:translate-x-0 lg:w-200 lg:pl-12 bg-base-300 py-2 px-4 rounded-field flex gap-1 justify-start shadow-md z-40">
              <p className="text-sm">
                Here is where you can edit your dashboard layout based on your screen size. The three options are
                Desktop,Tablet and Mobile.
                <br />
                The Blue icon represents the screen you are currently on. While in edit mode you can resize and drag
                cards to the position and size of your liking. When done hit the save button
              </p>
            </div>
          )}
        </div>

        {/* <div className="text-xs w-full xl:w-1/2 bg-base-300/40 py-2 px-4 rounded-field flex  gap-1 justify-start shadow-md">
          <FiInfo className="text-2xl text-primary" />

          <p className="w-full">
            Here is where you can edit your dashboard layout based on your screen size. The three options are
            Desktop,Tablet and Mobile.
            <br />
            The Blue icon represents the screen you are currently on. While in edit mode you can resize and drag cards
            to the position and size of your liking. When done hit the save button
          </p>
        </div> */}
      </div>
    </div>
  )
}
